<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Faqs"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/coins'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="peso"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Peso</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.peso"
                  label="Peso"
                  type="Number"
                  solo
                    hide-details="auto"
                    class="input-base custom-number"
                  prepend-inner-icon="fas fa-coins"
                >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.peso++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.peso = Math.max(0, data.peso - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="coins"
                rules="required|numberpositivo|without_decimals"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Coins</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.coins"
                  label="Coins"
                  type="Number"
                  solo
                    hide-details="auto"
                    class="input-base custom-number"
                  prepend-inner-icon="fas fa-coins"
                >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.coins++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.coins = Math.max(0, data.coins - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver, } from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Faqs.status,
      })
    },
    data() {
      return {
        storeName: 'Coins',
        title: "Coins",
        data: {
          peso: '',
          coins:'',
        }
      }
    }
  }
</script>
